var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostseedflexTabLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0344 17.3226C15.9952 18.6389 16.1361 20.3812 15.3963 21.8352C14.6596 23.2893 13.1672 24.2053 11.5402 24.2053H1.36184V20.5606H10.7875C10.7875 20.5606 11.1238 20.5958 11.6042 20.5606C11.6138 20.5606 11.6234 20.5606 11.6298 20.5606C11.8348 20.5349 12.0174 20.4132 12.1231 20.2339C12.248 20.0321 12.2544 19.7759 12.1455 19.5645L11.7323 19.1546L2.51803 9.94667L1.68212 9.11395C1.61486 9.0467 1.55721 8.97303 1.49956 8.89937C1.41629 8.78407 1.33942 8.66557 1.26896 8.54386C0.519521 7.27878 0.461872 5.70944 1.13445 4.3835C1.87428 2.92946 3.36356 2.01347 4.99375 2.01347H13.1928V0.332031L18.9994 3.87106L13.1928 7.40689V5.6614H4.99375C4.75355 5.6614 4.53256 5.7863 4.40765 5.99128C4.28595 6.19625 4.27634 6.44927 4.38523 6.66065L4.5838 6.85922L13.7981 16.0575L14.8486 17.108C14.8806 17.14 14.9094 17.1721 14.9415 17.2073C14.9735 17.2457 15.0055 17.2841 15.0312 17.3226H15.0344Z",
    fill: "#EA0029"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostseedflexTabLogo);
export default __webpack_public_path__ + "static/media/boostseedflexTabLogo.cf86ffe31a6a2f391d7becfd90db8d3a.svg";
export { ForwardRef as ReactComponent };